import { useCallback } from 'react';
import { useAtomCallback } from 'jotai/utils';
import { pendingAnnotationAtom, remainingItemsV2Atom } from '../atoms/side-panel-atoms';
export function useWindowedValidations() {
  const getPendingAnnotation = useAtomCallback(useCallback(get => get(pendingAnnotationAtom), []));
  const getRemainingItems = useAtomCallback(useCallback(get => get(remainingItemsV2Atom), []));
  const getValidations = useCallback(() => ({
    containsPendingItem: getPendingAnnotation().length > 0 || getRemainingItems().length > 0,
    containsRejectedAnnotation: false
  }), [getPendingAnnotation, getRemainingItems]);
  return {
    getValidations
  };
}